import { render, staticRenderFns } from "./PixClipboardCopy.vue?vue&type=template&id=c1afc762&"
import script from "./PixClipboardCopy.vue?vue&type=script&lang=js&"
export * from "./PixClipboardCopy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports